// ExtendedProperty name of CLP label on a message item.
export const LABEL_PROPERTY_NAME = 'msip_labels';
